export const mapNewsletterSignup = ({ content, settings }): Content.ContentModule => ({
	documentType: content?.contentType,
	content: {
		properties: {
			emailLabel: content.properties.emailLabel,
			emailPlaceholder: content.properties.emailPlaceholder,
			signupLabel: content.properties.signupLabel,
			newsletterTypes: content.properties.newsletterTypes,
		},
	},
	settings: {
		properties: settings?.properties ?? null,
	},
});
